import { useContext } from 'react';
import { LoyaltyEntitlementContext } from './LoyaltyEntitlementProvider';

export const useLoyaltyEntitlementInformation = () => {
  const context = useContext(LoyaltyEntitlementContext);
  if (!context) {
    throw new Error(
      'useLoyaltyEntitlement Information must be used within a LoyaltyEnrollmentProvider',
    );
  }
  return context;
};
